module.exports = __webpack_public_path__ + "img/fitbod_thumbnail.e509eb31.jpg";